import ListEvent from 'features/private-views/event/event-timeline/ListEvent'
import ListMasterItems from 'features/private-views/master-items'
import CompanySetting from 'features/private-views/settings/CompanySetting'
import PasswordSetting from 'features/private-views/settings/PasswordSetting'
import PinSetting from 'features/private-views/settings/PinSetting'
import ProfileSetting from 'features/private-views/settings/ProfileSetting'
import TeamSetting from 'features/private-views/settings/TeamSetting'
import ScannerSetting from 'features/private-views/settings/ScannerSetting'
import PrinterSetting from 'features/private-views/settings/PrinterSetting'
import AutoNumberSetting from 'features/private-views/settings/AutoNumberSetting'
import QRPrinting from 'features/private-views/qr-printing'
import PriceTable from 'features/private-views/settings/PriceTable'
import {
  BUSINESS_COMPANY,
  BUSINESS_EVENT,
  BUSINESS_INVENTORY,
  BUSINESS_PRODUCTION_UNIT,
  MANAGE,
  READ,
} from 'utils/subjectActions'
import {
  URL_EVENT,
  URL_PRODUCTION_UNIT,
  URL_MASTER_ITEMS,
  URL_SCANNER_SETTING,
  URL_PRINTER_SETTING,
  URL_AUTONUMBER_SETTING,
  URL_QR_PRINTING,
  URL_PRICE_TABLE,
} from 'utils/pathUrl'

export const profileSetting = [
  {
    category: 'Informasi Akun',
    path: '/pengaturan-profile',
    element: <ProfileSetting />,
    action: READ,
    subject: [BUSINESS_COMPANY, BUSINESS_PRODUCTION_UNIT],
    title: 'Profil Saya',
    description: 'Ubah informasi pribadi Anda.',
    icon: '👤',
    to: '/pengaturan-profile',
  },
]

export const settingRoutes = [
  {
    category: 'Inventori',
    path: URL_MASTER_ITEMS,
    element: <ListMasterItems action={READ} subject={BUSINESS_INVENTORY} />,
    action: READ,
    subject: [BUSINESS_INVENTORY],
    title: 'Manajemen Barang',
    description: 'Kelola master items produk dan skema',
    icon: '📦',
    to: URL_MASTER_ITEMS,
  },
  {
    category: 'Inventori',
    path: URL_PRICE_TABLE,
    element: <PriceTable />,
    action: READ,
    subject: [BUSINESS_INVENTORY],
    title: 'Tabel Harga',
    description: 'Kelola tabel harga untuk setiap barang.',
    icon: '💰',
    to: URL_PRICE_TABLE,
  },
  {
    category: 'Sistem',
    path: URL_QR_PRINTING,
    element: <QRPrinting />,
    action: READ,
    subject: [BUSINESS_INVENTORY],
    title: 'Cetak QR',
    description: 'Cetak label QR untuk inventori dan barang.',
    icon: '🏷️',
    to: URL_QR_PRINTING,
  },
  {
    category: 'Sistem',
    path: URL_SCANNER_SETTING,
    element: <ScannerSetting />,
    action: READ,
    subject: [BUSINESS_COMPANY],
    title: 'Scanner Barcode',
    description: 'Pengaturan dan uji coba scanner barcode.',
    icon: '📷',
    to: URL_SCANNER_SETTING,
  },
  {
    category: 'Sistem',
    path: URL_AUTONUMBER_SETTING,
    element: <AutoNumberSetting />,
    action: READ,
    subject: [BUSINESS_COMPANY],
    title: 'Format Penomoran',
    description: 'Atur format penomoran otomatis untuk dokumen sistem.',
    icon: '📝',
    to: URL_AUTONUMBER_SETTING,
  },
  // {
  //   category: 'Sistem',
  //   path: URL_PRINTER_SETTING,
  //   element: <PrinterSetting />,
  //   action: READ,
  //   subject: [BUSINESS_COMPANY],
  //   title: 'Printer Thermal',
  //   description: 'Hubungkan dan atur printer thermal Bluetooth.',
  //   icon: '🖨️',
  //   to: URL_PRINTER_SETTING,
  //   showIf: (profile) =>
  //     profile?.makerData?.userId === 922 ||
  //     profile?.userId === 922 ||
  //     profile?.makerData?.userId === 236 ||
  //     profile?.userId === 236,
  // },
  {
    category: 'Informasi Akun',
    path: '/pengaturan-perusahaan',
    element: <CompanySetting action={MANAGE} subject={BUSINESS_COMPANY} />,
    action: MANAGE,
    subject: [BUSINESS_COMPANY],
    title: 'Perusahaan',
    description: 'Kelola data perusahaan Anda.',
    icon: '🏢',
    to: '/pengaturan-perusahaan',
  },
  {
    category: 'Informasi Akun',
    path: '/pengaturan-tim',
    element: <TeamSetting action={MANAGE} subject={BUSINESS_COMPANY} />,
    action: MANAGE,
    subject: [BUSINESS_COMPANY],
    title: 'Tim',
    description: 'Kelola anggota tim Anda.',
    icon: '👥',
    to: '/pengaturan-tim',
  },
  {
    category: 'Informasi Akun',
    path: URL_PRODUCTION_UNIT,
    element: <TeamSetting action={READ} subject={BUSINESS_PRODUCTION_UNIT} />,
    action: READ,
    subject: [BUSINESS_PRODUCTION_UNIT],
    title: 'Unit Produksi',
    description: 'Kelola unit produksi Anda.',
    icon: '🗺️',
    to: URL_PRODUCTION_UNIT,
  },
  {
    category: 'Informasi Akun',
    path: URL_EVENT,
    element: <ListEvent action={READ} subject={BUSINESS_EVENT} />,
    action: READ,
    subject: [BUSINESS_EVENT],
    title: 'Event',
    description: 'Event',
    icon: '📋',
    to: URL_EVENT,
  },
  {
    category: 'Keamanan',
    path: '/pengaturan-password',
    element: <PasswordSetting />,
    action: MANAGE,
    subject: [BUSINESS_COMPANY],
    title: 'Ubah Password',
    description: 'Atur ulang password akun Anda dengan aman.',
    icon: '🔒',
    to: '/pengaturan-password',
    alwaysShow: true,
  },
  {
    category: 'Keamanan',
    path: '/pengaturan-pin',
    element: <PinSetting />,
    action: MANAGE,
    subject: [BUSINESS_COMPANY],
    title: 'Ubah PIN',
    description: 'Perbarui PIN Anda atau atur ulang jika lupa.',
    icon: '📱',
    to: '/pengaturan-pin',
    alwaysShow: true,
  },
]
